import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {OtpOppsettRessurs} from "../../../../../felles/tjenester/ressurser/OtpOppsettRessurs";

const css = require('./aktiverTotp.scss');

export class AktiverTotpKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmBrukerAktiverTotp', {
              bindings: {
                  vedFerdig: '&',
                  vedAvbryt: '&'
              },
              controller: AktiverTotpKontroller.forInjisering(),
              template: require('./aktiverTotp.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            OtpOppsettRessurs.regNavn,
            AktiverTotpKontroller
        ]
    }

    constructor(private $scope: IScope,
                private otpOppsettRessurs: OtpOppsettRessurs) {
    }

    vedFerdig: Function; //settes via bindings
    vedAvbryt: Function; //settes via bindings

    lagrer = false;
    qrKodeBilde: string;
    totpKode: string;
    oppsettBekreftet: l.TotpOppsettBekreftetModell;


    steg: 'scanqr'|'kvittering' = 'scanqr';

    gaaTilStegScanQr(){
        this.otpOppsettRessurs.initierOtpTotpOppsett().$promise
          .then(respons => {
              this.qrKodeBilde  = 'data:image/png;base64, '+respons.qrKodeBilde;
              this.steg = 'scanqr';
          })
    }

    otpValidert(){
        //console.debug('otpValidert', this.oppsettBekreftet);
        if (!this.oppsettBekreftet) return undefined;
        return this.oppsettBekreftet.verifisert;
    }

    otpOppdatert(){
        //console.debug('otpOppdatert', this.totpKode);
        this.oppsettBekreftet = null;
    }

    registrer() {
        this.lagrer = true;
        this.otpOppsettRessurs.bekreftOtpTotpOppsett(this.totpKode).$promise
            .then(oppsettBekreftet => {
                this.oppsettBekreftet = oppsettBekreftet;
                if (this.oppsettBekreftet.verifisert)
                    this.gaaTilVisKvittering();
            })
            .finally(() => this.lagrer = false);
    }

    gaaTilVisKvittering(){
        this.steg = 'kvittering';
    }

    lukk() {
       this.vedFerdig();
    }

    avbryt() {
       this.vedAvbryt();
    }

    $onInit(): void {
        this.gaaTilStegScanQr();
    }

}
